
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-engineering",
      function () {
        return require("private-next-pages/software-engineering.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-engineering"])
      });
    }
  